var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('assets-manager-modal',{attrs:{"id":_vm.id,"name":_vm.name,"multiple":_vm.multiple,"show":_vm.assetsManagerVisible,"registeredModuleName":_vm.registeredModuleName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }